import React from 'react';
import GridFilter from 'components/layouts/Account/GridFilter';
import { getUpdatedAccountTypeFilteringOptions } from 'state/account/SelectAccountsFilteringReducer';

export const chooseOptions = (
  accountTypes,
  accountOptions,
  customAccountGroups
) => {
  // Update account type options if custom group exists
  if (customAccountGroups && customAccountGroups.length) {
    // filters out from accountOptions
    const filteredAccounts = accountOptions.filter((accountType) =>
      accountTypes.includes(accountType.value)
    );
    const customGroup = customAccountGroups.map((group, index) => ({
      label: group.groupName,
      accountDescriptor: group.accountDescriptors.map(
        (accountId) => accountId.accountId
      ),
      value: `custom${index + 1}`
    }));
    const filtered = getUpdatedAccountTypeFilteringOptions(filteredAccounts, customGroup);

    // if > 2 (e.g. more than just a product type and one of retirement/nonretirement) then add 'all'; else remove
    // retirement/nonretirement for a disabled filter
    return filtered.length > 2
      ? [{ label: 'All', value: 'all' }, ...filtered]
      : filtered.filter(
          (accountType) =>
            accountType.value !== 'retirement' &&
            accountType.value !== 'nonRetirement'
        );
  }

  // filters out from accountOptions
  const filtered = accountOptions.filter((accountType) =>
    accountTypes.includes(accountType.value)
  );

  // if > 2 (e.g. more than just a product type and one of retirement/nonretirement) then add 'all'; else remove
  // retirement/nonretirement for a disabled filter
  return filtered.length > 2
    ? [{ label: 'All', value: 'all' }, ...filtered]
    : filtered.filter(
        (accountType) =>
          accountType.value !== 'retirement' &&
          accountType.value !== 'nonRetirement'
      );
};

const AccountTypeFilter = ({
  label,
  change,
  customAccountGroups,
  accountTypes,
  filterState: { selection, options }
}) => {
  const calculatedOptions = chooseOptions(
    accountTypes,
    options,
    customAccountGroups
  );

  return (
    <GridFilter
      label={label}
      options={calculatedOptions}
      change={change}
      disabled={calculatedOptions.length === 1}
      selection={selection}
    />
  );
};

export default AccountTypeFilter;
